// extracted by mini-css-extract-plugin
export default {"thank":"index_thank_V2P2u","thankTitle":"index_thankTitle_Ecpaw","thankBox":"index_thankBox_0B1fP"};